import { CheckIcon } from "@/components/Icon";
import { useSwipe } from "@/components/useSwipe";
import type { QueueEntry } from "@/lib/episode";
import { posterUrl } from "@/lib/poster";

interface Props {
  entry: QueueEntry;
  onMarkWatched: () => void;
  onMarkPrevious: () => void;
  onOpen: () => void;
}

export function QueueRow({ entry, onMarkWatched, onMarkPrevious, onOpen }: Props) {
  const { state, handlers } = useSwipe((direction) => {
    if (direction === "right") onMarkWatched();
    else onMarkPrevious();
  });

  const poster = posterUrl(entry.show.show.poster, "row");
  const classes = ["row", state.armed ? "armed" : "", state.direction === "left" ? "dir-left" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <li className={classes}>
      <div className="row-bg">
        <span className="row-bg-inner">
          <CheckIcon />
          <span>{state.direction === "left" ? "Unwatch" : "Watched"}</span>
        </span>
      </div>
      <button
        type="button"
        className={`row-fg${state.dragging ? " dragging" : ""}`}
        style={{ transform: `translateX(${state.offset}px)` }}
        onClick={onOpen}
        {...handlers}
      >
        {poster === null ? (
          <span className="poster" />
        ) : (
          <img className="poster" src={poster} alt="" loading="lazy" decoding="async" />
        )}
        <span className="meta">
          <span className="show-name">{entry.show.show.title}</span>
          <span className="sub">
            {entry.remaining === 1 ? "1 episode left" : `${entry.remaining} episodes left`}
          </span>
        </span>
        <span className="ep-right">
          <span className="code-lg">{entry.code}</span>
        </span>
      </button>
    </li>
  );
}
